const getters = {
    getCard(state) {
        return state.card;
    },
    getInitials(state) {
        return state.initials;
    },
    getLanguage(state) {
        return state.language;
    },
    getFirstName(state) {
        return state.firstName;
    },
    getLastName(state) {
        return state.lastName;
    },
    getExpirationDate(state) {
        return state.expirationDate;
    },
    getParonMember(state) {
        return state.paronMember.paronMember;
    }
}

export default getters;